import React from "react";

function HighlightsOfOurCry() {
  return (
    <>
      <div className="team-style-one-area default-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">AI Developer</h4>
                <h2 className="title split-text-right split-text-in-right">
                  Highlights of our Crypto Payment Services
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="team-style-one-items">
                <div className="team-style-one-item wow fadeInUp">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/13.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Multi-Currency Support</h4>
                    {/* <span>Ai Programmer</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/12.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Real-Time Conversion</h4>
                    {/* <span>Data Analyst</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/11.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Seamless Integration</h4>
                    {/* <span>Robotics Engineer</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/14.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Enhanced Security Protocols</h4>
                    {/* <span>Data Collector</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="team-style-one-items">
                <div className="team-style-one-item wow fadeInUp">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/13.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>User-Friendly Interface</h4>
                    {/* <span>Ai Programmer</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/12.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Customizable Solutions</h4>
                    {/* <span>Data Analyst</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="200ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/11.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Comprehensive Reporting and Analytics</h4>
                    {/* <span>Robotics Engineer</span> */}
                  </div>
                </div>

                <div
                  className="team-style-one-item wow fadeInUp"
                  data-wow-delay="300ms"
                >
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/14.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>24/7 Customer Support</h4>
                    {/* <span>Data Collector</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HighlightsOfOurCry;
